// Format rules a Field type checks before a form is saved; each returns the problem in Estonian, or '' when fine.
// The API checks the same again. The same rules as raamat-spa's lib/validate.js.

/** ISO 13616: country and check digits moved to the end, read as a number mod 97, must leave 1. */
const ibanSums = (s) => {
  const digits = (s.slice(4) + s.slice(0, 4)).replace(/[A-Z]/g, (ch) => String(ch.charCodeAt(0) - 55))
  let rest = 0
  for (const d of digits) rest = (rest * 10 + Number(d)) % 97
  return rest === 1
}

export const iban = (v) => {
  const s = String(v).replace(/\s/g, '').toUpperCase()
  return /^[A-Z]{2}\d{2}[A-Z0-9]{10,30}$/.test(s) && ibanSums(s) ? '' : 'IBAN ei ole õige'
}

export const email = (v) => (/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(String(v).trim()) ? '' : 'E-post ei ole õige')

/** A number within `min` / `max` (either may be missing); a comma is a decimal point. */
export const range = (v, min, max) => {
  const n = Number(String(v).replace(/\s/g, '').replace(',', '.'))
  if (Number.isNaN(n)) return 'Ei ole number'
  if (min != null && min !== '' && n < Number(min)) return `Vähemalt ${min}`
  if (max != null && max !== '' && n > Number(max)) return `Kuni ${max}`
  return ''
}

// An EU VAT number: two letters and 2–13 characters (Estonia: EE and nine digits).
export const vat = (v) =>
  /^[A-Z]{2}[0-9A-Z]{2,13}$/.test(String(v).replace(/\s/g, '').toUpperCase()) ? '' : 'KMKR number ei ole õige (nt EE101234567)'
